import { useQuery } from '@do/seashell/graphql';
import { Code } from '@do/walrus';
import * as React from 'react';
import { getAppManualScripts } from '../../graphql/generated-types/getAppManualScripts';
import getAppManualScriptsQuery from '../../graphql/queries/getAppManualScripts.gql';
import copy from '../copy';

interface Props {
  appName: string;
  appSlug: string;
}

const AppScriptsSection: React.FC<Props> = ({ appName, appSlug }) => {
  const { data } = useQuery<getAppManualScripts>(getAppManualScriptsQuery, {
    fetchPolicy: 'no-cache',
    variables: {
      payload: {
        app_slug: appSlug
      }
    }
  });

  const upgradeScript = data?.getAppManualScripts?.upgrade_script;
  const uninstallScript = data?.getAppManualScripts?.uninstall_script;

  return (
    <>
      {upgradeScript && (
        <>
          <h3>{copy.appScriptsSection.upgradeInstructions}</h3>
          <p>{copy.appScriptsSection.upgradeAppName(appName)}</p>
          <Code
            language="shell"
            download={upgradeScript.git_url}
            downloadLinkTitle={
              copy.appScriptsSection.downloadUpgradeInstructions
            }
          >
            {upgradeScript.content}
          </Code>
        </>
      )}

      {uninstallScript && (
        <>
          <h3>{copy.appScriptsSection.uninstallInstructions}</h3>
          <p>{copy.appScriptsSection.uninstallAppName(appName)}</p>
          <Code
            language="shell"
            download={uninstallScript.git_url}
            downloadLinkTitle={
              copy.appScriptsSection.downloadUninstallInstructions
            }
          >
            {uninstallScript.content}
          </Code>
        </>
      )}
    </>
  );
};

export default AppScriptsSection;
